import { render, staticRenderFns } from "./DomainConfiguration.vue?vue&type=template&id=270bb818&scoped=true&"
import script from "./DomainConfiguration.vue?vue&type=script&lang=js&"
export * from "./DomainConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./DomainConfiguration.vue?vue&type=style&index=0&id=270bb818&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270bb818",
  null
  
)

export default component.exports